// @flow
import React, {useReducer} from 'react';
import classNames from 'classnames';
import {ButtonLink} from 'sail/Button';
import {CopyReducer, copyText} from 'docs/data/integration-builder';

import {getLabelAndIcon} from '../../App/CopyButton';
import './CopyButton.scss';

type CopyTextProps = {|
  text: string,
  useTextAsLabel?: boolean,
|};

export const CopyButton = ({text, useTextAsLabel}: CopyTextProps) => {
  const [status, dispatch] = useReducer(CopyReducer, 'start');
  const copy = copyText(dispatch);

  const {icon, label} = getLabelAndIcon(status);

  return (
    <ButtonLink
      className={classNames(
        'CopyButton--step',
        useTextAsLabel && 'CopyButton--bold',
      )}
      icon={icon}
      label={useTextAsLabel ? text : label}
      color={'blue'}
      iconPosition="right"
      onClick={() => copy(text)}
    />
  );
};
